module.exports = __webpack_public_path__ + "static/media/EasyWords_web_2.44dd0f47.jpg";